<template>
  <div>
    <a-col :span="2" @click="openEmoji"><a-button icon="smile" shape="circle"> </a-button></a-col>
    <a-modal v-model="visible" title="表情选择">
      <template slot="footer">
        <a-button @click="handleOk">取消</a-button>
      </template>
      <a-tabs default-active-key="2">
        <a-tab-pane key="1">
          <span slot="tab">
            <a-icon type="qq" />
            QQ
          </span>
          <a-row>
            <a-col v-for="(item, index) in qList" :span="2" :key="index">
              <div class="qEmoji" @click="setEmoji(item.code)" :style="{ 'background-position': emojiPosition(index) }"></div>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab">
            <a-icon type="wechat" />
            WX
          </span>
          <a-row>
            <a-col v-for="(item, index) in eList" :span="2" :key="index">
              <div class="eList" @click="setEmoji(item)" :style="{ 'background-position': emojiPosition(index) }"></div>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>
<script>
import emoji from './emoji/emoji.js'
export default {
  data () {
    return {
      content: '',
      visible: false,
      eList: emoji.emojiList,
      qList: emoji.QQFaceList
    }
  },
  props: {
    input: {
      type: String,
      default: ''
    }
  },

  // watch: {
  //   content (newVal) {
  //     this.$emit('change', newVal)
  //   },
  //   value (newVal) {
  //     this.content = newVal
  //   }
  // },
  created () {},
  methods: {
    emojiPosition (index) {
      return '-' + (index % 15) * 29 + 'px -' + parseInt(index / 15) * 29 + 'px'
    },
    handleOk (e) {
      this.visible = false
    },
    doCopy (text) {
      this.$copyText(text)
        .then(message => {
          this.$message.success('复制完毕')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    openEmoji () {
      this.visible = true
    },
    setEmoji (emoji) {
      this.visible = false
      this.selectEmoji(emoji)
    },
    selectEmoji (emoji) {
      this.$emit('cencel', emoji, this.input)
      // var elInput = this.$refs[input] // 根据id选择器选中对象
      // var startPos = elInput.selectionStart // input 第0个字符到选中的字符
      // var endPos = elInput.selectionEnd // 选中的字符到最后的字符
      // if (startPos === undefined || endPos === undefined) return
      // var txt = elInput.value
      // // 将表情添加到选中的光标位置
      // // eslint-disable-next-line no-eval
      // var result = txt.substring(0, startPos) + eval("'" + emoji + "'") + txt.substring(endPos)
      // elInput.value = result // 赋值给input的value
      // // 重新定义光标位置
      // elInput.focus()
      // elInput.selectionStart = startPos + emoji.length
      // elInput.selectionEnd = startPos + emoji.length
      // this.content = result // 赋值给表单中的的字段
    }
  }
}
</script>

<style lang="less" scoped>
.qEmoji {
  background: url(./emoji/images/1.png);
  height: 25px;
  width: 25px;
  margin: 0 auto;
}
.eList {
  background: url(./emoji/images/2.png);
  height: 25px;
  width: 25px;
  margin: 0 auto;
}
</style>
